/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_VoiceInputs */

const en_playbar_voice = /** @type {(inputs: Playbar_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice`)
};

const es_playbar_voice = /** @type {(inputs: Playbar_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz`)
};

/**
* | output |
* | --- |
* | "Voice" |
*
* @param {Playbar_VoiceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_voice = /** @type {((inputs?: Playbar_VoiceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_VoiceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_voice(inputs)
	return en_playbar_voice(inputs)
});